var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCryptodataTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.16,
    height: 18.6,
    viewBox: "0 0 21.16 18.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cryptodata-telegram",
    transform: "translate(0.25 -31.534)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3692",
    "data-name": "Group 3692",
    transform: "translate(0 31.795)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3691",
    "data-name": "Group 3691"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17759",
    "data-name": "Path 17759",
    d: "M168.885,119.929l-8.494,5.232a1.271,1.271,0,0,0-.553,1.425l.918,3.227a.625.625,0,0,0,.605.458l.047,0a.626.626,0,0,0,.58-.545l.239-1.77a1.045,1.045,0,0,1,.323-.623l7.01-6.516a.559.559,0,0,0-.674-.886Zm-6.9,6.8a1.87,1.87,0,0,0-.578,1.116l-.116.858-.667-2.343a.445.445,0,0,1,.194-.5l6.223-3.833Z",
    transform: "translate(-153.343 -116.294)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17760",
    "data-name": "Path 17760",
    d: "M20.318,32.02a.949.949,0,0,0-.956-.162L.608,39.093a.95.95,0,0,0,.01,1.777L5,42.505,6.707,48a.949.949,0,0,0,1.507.454l2.547-2.076a.349.349,0,0,1,.425-.012L15.78,49.7a.95.95,0,0,0,1.489-.575l3.366-16.189A.95.95,0,0,0,20.318,32.02Zm-.489.751L16.463,48.96a.127.127,0,0,1-.2.076L11.669,45.7a1.172,1.172,0,0,0-1.428.04L7.694,47.817a.126.126,0,0,1-.2-.061L5.724,42.068a.412.412,0,0,0-.249-.263L.906,40.1a.127.127,0,0,1,0-.238l18.754-7.235h0a.127.127,0,0,1,.17.145Z",
    transform: "translate(0 -31.795)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptodataTelegram);
export default __webpack_public_path__ + "static/media/cryptodata-telegram.35cf940eae0389d2851fc7dbb04c3512.svg";
export { ForwardRef as ReactComponent };